import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AI_LOADING_OPTIONS, MAX_CHARACTERS_AMOUNT } from '../../constants/aiChatbot';
import { PROMPT_TYPE } from '../../constants/aiChatbot';
import { ChatTextInputIcon } from '../icons/ChatTextInputIcon';
import { CymbioSpinner } from '../common/Spinner';
import styles from './AiChatbot.module.scss';
import { adjustAiLoadingOption, adjustSearchText, adjustUserChatHistory } from '../../store/actions/aiChatbot';
import { addItemToHistoryChat, scrollToFinalChatItem } from '../../utils/aiChatbot';

export function ChatTextInput(props) {
  const { searchText, ui, history } = useSelector((state) => state.aiChatbot);
  const dispatch = useDispatch();

  const isLoadingChatbotAnswer = ui.loading[AI_LOADING_OPTIONS.CHATBOT_ANSWER];

  const onChange = (event) => {
    dispatch(adjustSearchText(event.target.value));
  };

  const submit = () => {
    if (searchText.length > MAX_CHARACTERS_AMOUNT) {
      return;
    }
    if (!searchText.length) {
      return;
    }
    if (isLoadingChatbotAnswer) {
      return;
    }
    const userPrompt = { content: searchText, promptType: PROMPT_TYPE.HUMAN, createdAt: new Date().toISOString() };
    addItemToHistoryChat(userPrompt, history);

    dispatch(adjustUserChatHistory(history));
    dispatch(adjustAiLoadingOption(AI_LOADING_OPTIONS.CHATBOT_ANSWER, true));
    props.onSubmit(searchText);
    scrollToFinalChatItem();
  };

  const handleInputKeyPress = (event) => {
    const isEnterKeyPressed = event.code === 'Enter' || event.charCode === 13 || event.which === 13;

    if (isEnterKeyPressed) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <div className={styles.chatTextInputContainer}>
      <input
        type="text"
        className={styles.chatTextInput}
        onChange={onChange}
        value={searchText}
        onKeyPress={handleInputKeyPress}
      />
      <div className={styles.chatTextInputIconContainer} onClick={submit}>
        {isLoadingChatbotAnswer ? <CymbioSpinner styleFunction={() => styles.spinner} /> : <ChatTextInputIcon />}
      </div>
    </div>
  );
}
